/**
 * 系统设置
 */
<template>
  <div style="margin-top: 20px;">
      <!-- 左边导航 -->
      <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
        <div v-if="accountAuth" class="mouse" :class="{'selected':accountAuthCh}" @click="clickLabel('account')">账户管理</div>
        <!-- <div v-if="labelNum>=2" style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div v-if="roleAuth" class="mouse" :class="{'selected':roleAuthCh}" @click="clickLabel('role')">角色管理</div>
        <!-- <div v-if="labelNum>=3" style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div v-if="departmentAuth" class="mouse" :class="{'selected':departmentAuthCh}" @click="clickLabel('department')">部门管理</div>
        <!-- <div v-if="labelNum>=4" style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div v-if="menuAuth" class="mouse" :class="{'selected':menuAuthCh}" @click="clickLabel('menu')">菜单管理</div>
        <!-- <div v-if="labelNum>=5" style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div> -->
        <div v-if="dictAuth" class="mouse" :class="{'selected':dictAuthCh}" @click="clickLabel('dict')">数据字典</div>
      </div> 
      <!-- 右侧按钮 -->
      <div style="float: right;display: flex;">
        <el-button size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
        <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleEditAccount" v-if="accountAuthCh">新增账户</el-button>
        <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleEditRole" v-if="roleAuthCh">新增角色</el-button>
        <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleEditMenu" v-if="menuAuthCh">新增菜单</el-button>
        <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleEditDepartment" v-if="departmentAuthCh">新增部门</el-button>
        <el-button size="small" icon="el-icon-plus" class="clue-btn" @click="handleEditdict" v-if="dictAuthCh">新增字典</el-button>
        <!-- <el-input v-model="formInline.search" placeholder="请输入需要查询的条件" clearable class="clue-search">
          <el-button slot="append" icon="el-icon-search" class="clue-search-btn"></el-button>
        </el-input> -->
      </div>

    <!-- 账户列表 -->
    <div v-if="accountAuthCh">
      <el-table size="small" :data="accountData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="real_name" align="center" label="姓名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="role_name" align="center" label="角色" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="department_name" align="center" label="部门" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态" :formatter="matterStatus" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditAccount(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="success" @click="resetPwd(scope.$index, scope.row)">重置密码</el-button>
            <!-- <el-button size="mini" type="danger" @click="delAccount(scope.$index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 角色列表 -->
    <div v-if="roleAuthCh">
      <el-table size="small" :data="roleData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="role_name" align="center" label="角色名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sign" align="center" label="签名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditRole(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delRole(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 菜单列表 -->
    <div v-if="menuAuthCh">
      <el-table size="small" :data="menuData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="permission_name" align="center" label="菜单名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="type" align="center" label="类型" :formatter="matterType" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="flag" align="center" label="签名" show-overflow-tooltip>
        </el-table-column>
         <el-table-column prop="sort" align="center" label="排序值" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditMenu(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delMenu(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 部门管理 -->
    <div v-if="departmentAuthCh">
      <el-table size="small" :data="departmentData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="department_name" align="center" label="部门名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="department_sign" align="center" label="部门签名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="super_name" align="center" label="上级部门" show-overflow-tooltip>
        </el-table-column>
         <el-table-column prop="admin_name" align="center" label="操作人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditDepartment(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delDepartment(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 数据字典 -->
    <div v-if="dictAuthCh">
      <el-table size="small" :data="dictData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="name" align="center" label="名称" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="type" align="center" label="类型" :formatter="matterType" show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column prop="value" align="center" label="对应值" show-overflow-tooltip>
        </el-table-column>
         <el-table-column prop="cate_name" align="center" label="所属类别名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="cate_sign" align="center" label="所属类别签名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="操作人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="desc" align="center" label="备注" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditdict(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="delDict(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑页面 -->
    <!-- 账户编辑 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="editAccountVisible" width="50%" @click="closeDialog('accountForm')">
      <el-form label-width="120px" :model="accountForm" :rules="accountFormRule" ref="accountForm">
        <el-form-item label="账户" prop="mobile">
            <el-input size="small" v-model="accountForm.mobile" auto-complete="off" placeholder="请输入手机号作为登录账户" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="real_name">
            <el-input size="small" v-model="accountForm.real_name" auto-complete="off" placeholder="请输入真实姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group type="kind" v-model="accountForm.sex"> 
              <el-radio v-model="accountForm.sex" :label="1" style="font-size: 25px">男</el-radio>
              <el-radio v-model="accountForm.sex" :label="2">女</el-radio>
              <el-radio v-model="accountForm.sex" :label="3">保密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
            <el-input size="small" v-model="accountForm.email" auto-complete="off" placeholder="请输入邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group type="kind" v-model="accountForm.status"> 
              <el-radio v-model="accountForm.status" :label="1" style="font-size: 25px">正常</el-radio>
              <el-radio v-model="accountForm.status" :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="部门" prop="department_id">
          <el-select size="small" v-model="accountForm.department_id" placeholder="请选择">
            <el-option v-for="type in departmentArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="role_id">
          <el-select size="small" v-model="accountForm.role_id" placeholder="请选择">
            <el-option v-for="type in roleArr" :label="type.key" :value="type.value" :key="type.value" :disabled="type.roleStatus"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="editAccount('accountForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("accountForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 角色编辑 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="editRoleVisible" width="50%" @click="closeDialog('roleForm')">
      <el-form label-width="120px" :model="roleForm" :rules="roleFormRule" ref="roleForm">
        <el-form-item label="角色名称" prop="role_name"> 
            <el-input size="small" v-model="roleForm.role_name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色简称" prop="short_name"> 
            <el-input size="small" v-model="roleForm.short_name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色签名" prop="sign"> 
            <el-input size="small" v-model="roleForm.sign" auto-complete="off" clearable></el-input>
        </el-form-item>
        <!-- 菜单权限 -->
        <el-form-item label="菜单权限">
            <el-tree class="treeclass" 
                      ref="menuTree" 
                      :data="menuAuthData" 
                      default-expand-all
                      :props="defaultProps"
                      :default-checked-keys="checkMenu"
                      node-key="permission_id" 
                      check-on-click-node
                      show-checkbox>
            </el-tree>
        </el-form-item>
        <!-- 按钮权限 -->
        <el-form-item label="按钮权限">
            <el-tree class="treeclass" 
                      ref="btnTree" 
                      :data="btnAuthData" 
                      :props="defaultProps"
                      :default-checked-keys="checkBtn"
                      node-key="flag" 
                      check-on-click-node
                      show-checkbox>
            </el-tree>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="editRole('roleForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("roleForm")'>取消</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
    <!-- 菜单编辑 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="editMenuVisible" width="50%" @click="closeDialog('menuForm')">
      <el-form label-width="120px" :model="menuForm" :rules="menuFormRule" ref="menuForm">
        <el-form-item label="菜单名称" prop="permission_name"> 
            <el-input size="small" v-model="menuForm.permission_name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group type="kind" v-model="menuForm.type"> 
              <el-radio v-model="menuForm.type" :label="1" style="font-size: 25px">菜单</el-radio>
              <el-radio v-model="menuForm.type" :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="前端路由" prop="permission_index">
            <el-input size="small" v-model="menuForm.permission_index" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
            <el-input size="small" v-model="menuForm.icon" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="签名" prop="flag">
            <el-input size="small" v-model="menuForm.flag" auto-complete="off"></el-input>
        </el-form-item>
          <el-form-item label="排序值" prop="sort">
            <el-input size="small" v-model="menuForm.sort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="editMenu('menuForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("menuForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 部门编辑 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="editDepartmentVisible" width="600px" @click="closeDialog('departmentForm')">
      <el-form label-width="120px" :model="departmentForm" :rules="departmentFormRule" ref="departmentForm">
        <el-form-item label="部门名称" prop="department_name"> 
            <el-input size="small" v-model="departmentForm.department_name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="部门签名" prop="department_sign">
            <el-input size="small" v-model="departmentForm.department_sign" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="上级部门" prop="super_id">
          <el-select size="small" v-model="departmentForm.super_id" placeholder="请选择">
            <el-option v-for="type in departmentArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="editDepartment('departmentForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("departmentForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 数据字典编辑 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="editDictVisible" width="50%" @click="closeDialog('dictForm')">
      <el-form label-width="120px" :model="dictForm" :rules="dictFormRule" ref="dictForm">
        <el-form-item label="名称" prop="name"> 
            <el-input size="small" v-model="dictForm.name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group type="kind" v-model="menuForm.type"> 
              <el-radio v-model="menuForm.type" :label="1" style="font-size: 25px">菜单</el-radio>
              <el-radio v-model="menuForm.type" :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="对应值" prop="value">
            <el-input size="small" v-model="dictForm.value" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="类别名称" prop="cate_name">
            <el-input size="small" v-model="dictForm.cate_name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="类别签名" prop="cate_sign">
            <el-input size="small" v-model="dictForm.cate_sign" auto-complete="off" clearable></el-input>
        </el-form-item>
          <el-form-item label="备注" prop="desc">
            <el-input size="small" v-model="dictForm.desc" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="editDict('dictForm')">提交</el-button>
            <el-button size="mini" @click='closeDialog("dictForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="rightDrawer" @click="handleDrawerOpen">
      《《
    </div>

    <el-drawer 
    :visible.sync="drawer" 
    :direction="direction" 
    :before-close="handleDrawerClose" 
    size="360px" 
    title="条件查询" 
    :show-close="false"
    :wrapperClosable="true"
    class="searchDrawer" 
    >
      <div style="margin-left: 20px;">
          <el-form :inline="true" :model="formInline">
            <el-form-item label="模糊搜索" style="width: 320px;">
              <el-input size="small" v-model="formInline.search_value" placeholder="请输入关键词" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="账户姓名" v-if="accountAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.real_name" placeholder="请输入账户姓名" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="角色名称" v-if="roleAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.role_name" placeholder="请输入角色名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="部门名称" v-if="departmentAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.department_name" placeholder="请输入部门名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="菜单名称" v-if="menuAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.menu_name" placeholder="请输入菜单名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="菜单类型" v-if="menuAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.menu_type" placeholder="请输入菜单类型" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="字典名称" v-if="dictAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.dict_name" placeholder="请输入字典名称" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item label="字典类别" v-if="dictAuthCh" style="width: 320px;">
              <el-input size="small" v-model="formInline.dict_cate" placeholder="请输入字典类别" clearable style="width: 250px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="searchData">查询</el-button>
              <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
              <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
            </el-form-item>
          </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { 
  getAccountPageList, 
  getRolePageList, 
  getMenuPageList,
  editMenu,
  delMenu,
  editRole,
  getAuthMenu,
  delRole, 
  getRoleInfo,
  getRoleAll,
  editAccount,
  resetAccountPwd,
  getDepartmentList,
  getDictList,
  editDict,
  delDict,
  getDepartmentArr,
  editDepartment,
  delDepartment } from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      // 控制label是否选中
      accountAuthCh: false,
      roleAuthCh: false,
      menuAuthCh: false,
      departmentAuthCh: false,
      dictAuthCh: false,
      // 控制label是否显示
      accountAuth: false,
      roleAuth: false,
      menuAuth: false,
      departmentAuth: false,
      dictAuth: false,

      labelNum: 0,

      // 控制弹窗显示
      editMenuVisible: false,
      editRoleVisible: false,
      editAccountVisible: false,
      editDepartmentVisible: false,
      editDictVisible: false,

      title: '',

      // 搜索框开始
      drawer: false,
      direction: 'rtl',
      // 搜索框结束

      // 菜单权限(all)
      menuAuthData: [],
      // 按钮权限(all)
      btnAuthData: [],
      // 菜单权限(checked)
      checkMenu: [],
      // 按钮权限(checked)
      checkBtn: [],
      // 角色
      roleArr: [],
      // 部门
      departmentArr: [],

      defaultProps: {
        children: 'children',
        label: 'permission_name'
      },

      formInline: {
        page: 1,
        ps: 15,
        search_value: '',
        real_name: '',
        role_name: '',
        department_name: '',
        menu_name: '',
        menu_type: '',
        dict_cate: '',
        dict_name: ''
      },
      accountForm: {
        uid: '',
        mobile: '',
        real_name: '',
        email: '',
        role_id: '',
        sex: 3,
        status: 1,
        department_id: ''
      },
      roleForm: {
        role_id: '',
        role_name: '',
        short_name: '',
        sign: '',
        btn_auth: [],
        menu_auth: []
      },
      menuForm: {
        permission_id: 0,
        pid: 0,
        permission_name: '',
        permission_index: '',
        icon: '',
        is_nav_three_view: '',
        type: '',
        flag: '',
        sort: 255
      },
      departmentForm: {
        department_id: 0,
        department_name: '',
        department_sign: '',
        super_id: ''
      },
      dictForm: {
        id: '',
        name: '',
        cate_name: '',
        cate_sign: '',
        value: '',
        desc: ''
      },
      // 按钮权限
      buttonAuth: [],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      accountData: [], //账户数据
      roleData: [], //角色数据
      menuData: [], //菜单数据
      departmentData: [], //部门数据
      dictData: [], //数据字典
      listData: [], //用户数据


      // rules
      menuFormRule: {
        permission_name:[{ required: true, message: '请输入名称', trigger: 'blur' }],
        type:[{ required: true, message: '请选择类型', trigger: 'blur' }],
        flag:[{ required: true, message: '请输入签名', trigger: 'blur' }]
      },
      roleFormRule: {
        role_name:[{ required: true, message: '请输入名称', trigger: 'blur' }],
        sign:[{ required: true, message: '请输入签名', trigger: 'blur' }],
      },
      accountFormRule: {
        mobile:[{ required: true, message: '请输入手机号作为登录账户', trigger: 'blur' }],
        real_name:[{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        role_id:[{ required: true, message: '请选择角色', trigger: 'blur' }],
      },
      departmentFormRule: {
        department_name:[{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        department_sign:[{ required: true, message: '请输入部门签名', trigger: 'blur' }],
        super_id:[{ required: true, message: '请选择上级部门', trigger: 'blur' }],
      },
      dictFormRule: {
        name:[{ required: true, message: '请输入名称', trigger: 'blur' }],
        cate_name:[{ required: true, message: '请输入类别名称', trigger: 'blur' }],
        cate_sign:[{ required: true, message: '请输入类别签名', trigger: 'blur' }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 15
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // 获取按钮权限
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    let lable_num = this.labelNum
    if(btnAuth.includes("accountAuth")){
      this.accountAuth = true
      this.accountAuthCh = true
      lable_num = lable_num + 1
      // 获取数据
      this.getAccountData()
    }
    if(btnAuth.includes("roleAuth")){
      this.roleAuth = true
      lable_num = lable_num + 1
      if(!this.accountAuth){
        this.roleAuthCh = true
        // 获取数据
        this.getRoleData()
      }
    }
    if(btnAuth.includes("menuAuth")){
      this.menuAuth = true
      lable_num = lable_num + 1
      if(!this.accountAuth&&!roleAuth){
        this.menuAuthCh = true
        // 获取数据
        this.getMenuData()
      }
    }
    if(btnAuth.includes("departmentAuth")){
      this.departmentAuth = true
      lable_num = lable_num + 1
      if(!this.accountAuth&&!roleAuth&&!this.menuAuth){
        this.departmentAuthCh = true
        // 获取数据
        this.getDepartmentData()
      }
    }
    if(btnAuth.includes("dictAuth")){
      this.dictAuth = true
      lable_num = lable_num + 1
      if(!this.accountAuth&&!roleAuth&&!this.menuAuth&&!this.departmentAuth){
        this.dictAuthCh = true
        // 获取数据
        this.getDictData()
      }
    }
    this.labelNum = lable_num
    this.getAuthMenuData()
    this.getAllRole()
    // this.getdata(this.formInline)
    // this.accountAuthCh =  true
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取账户列表
    getAccountData() {
      this.loading = true
      getAccountPageList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.accountData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
        }
      })
    },
     // 获取角色列表
    getRoleData() {
      this.loading = true
      getRolePageList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.roleData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
        }
      })
    },
     // 获取菜单列表
    getMenuData() {
      this.loading = true
      getMenuPageList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.menuData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
        }
      })
    },
    // 获取部门列表
    getDepartmentData() {
      this.loading = true
      getDepartmentList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.departmentData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
        }
      })
    },
    // 获取数据字典列表
    getDictData() {
      this.loading = true
      getDictList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.dictData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
        }
      })
    },
    // 获取菜单列表(角色管理all)
    getAuthMenuData() {
      getAuthMenu()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.menuAuthData = res.data.menu
          this.btnAuthData = res.data.btn
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    getAllRole() {
      getRoleAll()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.roleArr = res.data
        }
      })
    },
    clickLabel(label) {
      this.formInline.page = 1
      if(label == 'account'){
        this.getAccountData()
        this.accountAuthCh = true;
        this.roleAuthCh = false;
        this.menuAuthCh = false;
        this.departmentAuthCh = false;
        this.dictAuthCh = false;
      }else if(label == 'role') {
        this.getRoleData()
        this.roleAuthCh = true;
        this.accountAuthCh = false;
        this.menuAuthCh = false;
        this.departmentAuthCh = false;
        this.dictAuthCh = false;
      }else if(label == 'menu'){
        this.getMenuData()
        this.menuAuthCh = true;
        this.accountAuthCh = false;
        this.roleAuthCh = false;
        this.departmentAuthCh = false;
        this.dictAuthCh = false;
      }else if(label == 'department'){
        this.getDepartmentData()
        this.departmentAuthCh = true;
        this.menuAuthCh = false;
        this.accountAuthCh = false;
        this.roleAuthCh = false;
        this.dictAuthCh = false;
      }else{
        this.getDictData()
        this.dictAuthCh = true;
        this.roleAuthCh = false;
        this.departmentAuthCh = false;
        this.menuAuthCh = false;
        this.accountAuthCh = false;
      }
      this.formInline.search_value = ''
      this.formInline.real_name = ''
      this.formInline.role_name = ''
      this.formInline.department_name = ''
      this.formInline.menu_name = ''
      this.formInline.dict_cate = ''
      this.formInline.dict_name = ''
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      if(this.accountAuthCh){
          this.getAccountData()
      }else if(this.roleAuthCh){
          this.getRoleData()
      }else if(this.menuAuthCh){
          this.getMenuData()
      }else if(this.departmentAuthCh){
          this.getDepartmentData()
      }else{
          this.getDictData()
      }
    },
    matterType: function(obj) {
      if(obj.type == 1){
          return '菜单'
      }else if(obj.type == 2){
          return '按钮'
      }else{
          return '其他'
      }
    },  
    matterStatus: function(obj) {
      if(obj.status == 1){
          return '正常'
      }else if(obj.status == 2){
          return '停用'
      }else{
          return '其他'
      }
    }, 
    // 搜索事件
    search() {
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
    },
    // 显示账户编辑页面
    handleEditAccount: function(index, row) {
      if(row){
        // 编辑
        this.accountForm.uid = row.uid
        this.accountForm.real_name = row.real_name
        this.accountForm.mobile = row.mobile
        this.accountForm.email = row.email
        this.accountForm.role_id = row.role_id
        this.accountForm.sex = row.sex
        this.accountForm.status = row.status
        this.accountForm.department_id = row.department_id
      }else{
        // 新增
        this.accountForm.uid = ''
        this.accountForm.real_name = ''
        this.accountForm.mobile = ''
        this.accountForm.email = ''
        this.accountForm.role_id = ''
        this.accountForm.sex = 3
        this.accountForm.status = 1
        this.accountForm.department_id = ''
      }
      // 查询所有部门
      getDepartmentArr()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.departmentArr = res.data
          this.editAccountVisible = true
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 重置账户密码
    resetPwd(index, row) {
      this.$confirm('确定重置该账户密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        resetAccountPwd({uid: row.uid})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 显示角色编辑页面
    handleEditRole: function(index, row) {
      if(row){
       let param = {role_id: row.role_id}
        getRoleInfo(param)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.title = '编辑角色'
            this.roleForm.role_id = row.role_id
            this.roleForm.role_name = row.role_name
            this.roleForm.short_name = row.short_name
            this.roleForm.sign = row.sign
            this.checkBtn = res.data.btn
            this.checkMenu =  res.data.menu
            this.editRoleVisible = true
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }else{
        // 新增
       this.title = '新增角色'
       this.roleForm.role_id = ''
       this.roleForm.role_name = ''
       this.roleForm.short_name = ''
       this.roleForm.sign = ''
       this.checkBtn = []
       this.checkMenu = []
       this.editRoleVisible = true
      }
      
    },
    // 显示菜单编辑页面
    handleEditMenu: function(index, row) {
      if(row){
        // 编辑
        this.title = "菜单编辑"
        this.menuForm.permission_id = row.permission_id
        this.menuForm.pid = row.pid
        this.menuForm.permission_name = row.permission_name
        this.menuForm.permission_index = row.permission_index
        this.menuForm.icon =  row.icon
        this.menuForm.is_nav_three_view = row.is_nav_three_view
        this.menuForm.type = row.type
        this.menuForm.flag = row.flag
        this.menuForm.sort = row.sort
      }else{
        // 新增
        this.title = "菜单新增"
        this.menuForm.permission_id = 0
        this.menuForm.pid = 0
        this.menuForm.permission_name = ''
        this.menuForm.permission_index = ''
        this.menuForm.icon =  ''
        this.menuForm.is_nav_three_view = ''
        this.menuForm.type = ''
        this.menuForm.flag = ''
        this.menuForm.sort = 255
      }
      this.editMenuVisible = true
    },

    // 开启搜索框
    handleDrawerOpen() {
      let that = this
      // getSearchSeller()
      // .then(res=>{
      //   if(res.code == 200){
      //     that.searchSeller = res.data
      //   }else{
      //     that.searchSeller = []
      //   }
      // })
      this.drawer = true
    },

      // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },

    // 显示部门编辑页面
    handleEditDepartment: function(index, row) {
      if(row){
        this.departmentForm.id = row.id
        this.departmentForm.department_name = row.department_name
        this.departmentForm.department_sign = row.department_sign
        this.departmentForm.super_id = row.super_id
        
      }else{
        this.departmentForm.id = ''
        this.departmentForm.department_name = ''
        this.departmentForm.department_sign = '',
        this.departmentForm.super_id = ''

      }
      // 查询所有部门
      getDepartmentArr()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.departmentArr = res.data
          this.editDepartmentVisible = true
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 显示数据字典编辑页面
    handleEditdict: function(index, row) {
      if(row){
        this.title = '编辑字典'
        this.dictForm.id = row.id
        this.dictForm.name = row.name
        this.dictForm.cate_name = row.cate_name
        this.dictForm.cate_sign = row.cate_sign
        this.dictForm.value = row.value
        this.dictForm.desc = row.desc
      }else{
        this.title = '添加字典'
        this.dictForm.id = ''
        this.dictForm.name = ''
        this.dictForm.cate_name = ''
        this.dictForm.cate_sign = ''
        this.dictForm.value = ''
        this.dictForm.desc = ''
      }
      this.editDictVisible = true
    },
    // 编辑菜单
    editMenu(menuForm) {
      console.log(this.menuForm)
      //校验参数
      this.$refs[menuForm].validate(valid => {
        if(valid){
          editMenu(this.menuForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.editMenuVisible = false
              this.getMenuData()
            }else{
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        }else{
          return false
        }
      })
    },
    // 删除菜单
    delMenu(index, row) {
      let permission_id = row.permission_id
       this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delMenu({permission_id: permission_id})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getMenuData()
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除部门
    delDepartment(index ,row) {
      let id = row.id
       this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delDepartment({id: id})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getDepartmentData()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 编辑角色
    editRole(roleForm) {
      //校验参数
      this.$refs[roleForm].validate(valid => {
        if(valid){
          let menuKeys = this.$refs.menuTree.getCheckedKeys().concat(this.$refs.menuTree.getHalfCheckedKeys())
          let btnKeys = this.$refs.btnTree.getCheckedKeys().concat(this.$refs.btnTree.getHalfCheckedKeys())
          if(menuKeys.length <= 0){
              this.$message({
                type: 'error',
                message: '菜单权限不能为空!'
              })
              return false
          }
          if(btnKeys.length <= 0){
              this.$message({
                type: 'error',
                message: '按钮菜单不能为空!'
              })
              return false
          }
          this.roleForm.menu_auth = JSON.stringify(menuKeys)
          this.roleForm.btn_auth = JSON.stringify(btnKeys)
          editRole(this.roleForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.editRoleVisible = false
              this.getRoleData()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

        }
      })
    },
    // 删除角色
    delRole(index,row){
      let role_id = row.role_id
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delRole({role_id: role_id})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getRoleData()
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除字典
    delDict(index,row){
      let id = row.id
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        delDict({id: id})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getDictData()
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 编辑账户
    editAccount(accountForm) {
      this.$refs[accountForm].validate(valid => {
        if(valid){
          editAccount(this.accountForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                  type: 'success',
                  message: res.msg
               })
              this.editAccountVisible = false
              this.getAccountData()
            }else{
               this.$message({
                  type: 'error',
                  message: res.msg
               })
                return false
            }
          })
        }
      })
    },
    // 编辑部门
    editDepartment(departmentForm) {
      this.$refs[departmentForm].validate(valid => {
        if(valid){
          editDepartment(this.departmentForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                  type: 'success',
                  message: res.msg
               })
              this.editDepartmentVisible = false
              this.getDepartmentData()
            }else{
               this.$message({
                  type: 'error',
                  message: res.msg
               })
                return false
            }
          })
        }
      })
    },
    // 编辑字典
    editDict(dictForm) {
      this.$refs[dictForm].validate(valid => {
        if(valid){
          editDict(this.dictForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                  type: 'success',
                  message: res.msg
               })
              this.editDictVisible = false
              this.getDictData()
            }else{
               this.$message({
                  type: 'error',
                  message: res.msg
               })
                return false
            }
          })
        }
      })
    },
    // 查询搜索框
    searchData() {
      this.formInline.page = 1
      if(this.accountAuthCh){
        this.getAccountData()
      }else if(this.roleAuthCh){
        this.getRoleData()
      }else if(this.departmentAuthCh){
        this.getDepartmentData()
      }else if(this.menuAuthCh){
        this.getMenuData()
      }else{
        this.getDictData()
      }
    },
    // 重置搜索框
    resetSearch() {
      this.formInline.search_value = ''
      this.formInline.real_name = ''
      this.formInline.role_name = ''
      this.formInline.department_name = ''
      this.formInline.menu_name = ''
      this.formInline.menu_type = ''
      this.formInline.dict_cate = ''
      this.formInline.dict_name = ''
      if(this.accountAuthCh){
        this.getAccountData()
      }else if(this.roleAuthCh){
        this.getRoleData()
      }else if(this.departmentAuthCh){
        this.getDepartmentData()
      }else if(this.menuAuthCh){
        this.getMenuData()
      }else{
        this.getDictData()
      }

    },
      // 刷新页面数据
    refreshData() {
      if(this.accountAuthCh){
        this.getAccountData()
      }else if(this.roleAuthCh){
        this.getRoleData()
      }else if(this.menuAuthCh){
        this.getMenuData()
      }else if(this.departmentAuthCh){
        this.getDepartmentData()
      }else {
        this.getDictData()
      }
    },
    // 关闭编辑、增加弹出框0
    closeDialog(formName) {
      if(formName == 'menuForm'){
        this.editMenuVisible = false
      }else if(formName == 'roleForm'){
        this.editRoleVisible = false
      }else if(formName == 'accountForm'){
        this.editAccountVisible = false
      }else if(formName == 'departmentForm'){
        this.editDepartmentVisible = false
      }else if(formName == 'dictForm'){
        this.editDictVisible = false
      }
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.clue-search {
  margin-left: 20px;
  background-color: #E4E4E4;
}
.clue-search-btn {
  background-color: #333333 !important;
  color: #FFFFFF !important;
  font-weight: 700 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.u-btn {
  display: none;
}
.mouse {
  cursor: pointer;
  color: #D9D9D9;
  margin-right: 18px;
}
.selected {
  color: #333333;
}
.treeclass {
  margin-top: 8px;
  display: flex !important;
  flex-flow: wrap !important;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
.searchDrawer>>>.el-form-item {
  margin-bottom: 10px;
}
.clueDatePicker>>>.el-range-editor.el-input__inner {
  padding: 1px 4px;
}
.clueDatePicker>>>.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 215px;
  height: 34px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/crm/system.vue